<!--
 * 文件名：labelToolDetail.vue
 * 描述：标注系统嵌入详情页（v26.3.3，F6 待整改 / F9 审核共用）。
 *       mode=rectify（待整改）：驳回信息摘要（驳回时间/驳回人/驳回原因/当前条目）+ 嵌 LS 标注二次编辑页（无 mode 纯标注态，恒可编辑——闭环=最后一个任务更新完后的整包提交，提交前不转只读）；
 *         10-09：四条目跟随 LS 当前选中条目——LS selectTask 回传 TASK_CHANGED（taskId），本页据此重拉 reject-info；
 *       mode=audit（审核）：嵌 LS 审核界面（ReviewControls/DataManager），LS mode 按行阶段位置映射——
 *       FIRST_REVIEW→review-edit|readonly / SECOND_REVIEW→qc-edit|readonly / QC→恒 acceptance-readonly / COMPLETED→acceptance-detail。
 *       嵌入=micro-app iframe 沙箱档（LabelToolEmbed），免登=token 经 data 通道注入。
 * 数据层（09-11）：/label-task/label-url + /label-task/reject-info 由 FBT 后端自建（F0），
 *       数据结构对齐 fe（label-url→LS 项目页地址；reject-info→label-review-record 驳回记录）；
 *       F0 未就绪时走 labelTaskApi 本地 mock（MOCK_ENABLED）。
-->
<template>
  <div class="label-tool-detail" >
    <div class="header">
      <div class="back" @click="goBack">返回</div>
      <div class="page-title">{{ isRectify ? "待整改任务" : "审核任务" }}</div>
      <div class="proj-name">{{ $route.query.projectName || $route.query.taskTitle || "" }}</div>
    </div>

    <!-- 待整改：驳回信息摘要 -->
    <div class="reject-summary" v-if="isRectify && rejectInfo">
      <el-row :gutter="16">
        <el-col :span="6"><span class="sum-label">驳回时间：</span>{{ rejectInfo.rejectTime || "-" }}</el-col>
        <el-col :span="6"><span class="sum-label">驳回人：</span>{{ rejectInfo.rejectStaffName || "-" }}</el-col>
        <el-col :span="6"><span class="sum-label">当前条目：</span>{{ rejectInfo.currentItem || "-" }}</el-col>
        <el-col :span="6"><span class="sum-label">整改汇总：</span>需整改 {{ rejectInfo.needRectifyCount || 0 }} / 已整改 {{ rejectInfo.rectifiedCount || 0 }}</el-col>
      </el-row>
      <div class="reject-reason"><span class="sum-label">驳回原因：</span>{{ rejectInfo.rejectReason || "-" }}</div>
    </div>

    <!-- 整改页：等驳回摘要（reject-info）返回后再渲染嵌入（摘要失败也放行，降级可编辑）——
         2026-10-16 口径③后待整改恒 isView=false，原"摘要返回翻转 isView 二次加载"问题已随 rejectDone 移除，守卫仅保首屏一致 -->
    <div v-if="entry && entry.mode != null && entry.lsSyncState !== 'SYNCED'" class="fallback">
      <p>审核工具状态同步中，请稍后重新进入</p>
    </div>
    <div class="stage" v-else-if="entry && entry.canEnter === true && toolUrl && (!isRectify || rejectInfoLoaded)">
      <label-tool-embed
        tool-type="labelStudio"
        :url="toolUrl"
        :task-id="embedTaskId"
        :mode="embedMode"
        :is-view="embedIsView"
        :stage-rule-code="embedStageRuleCode"
        :rectify="isRectify"
        :data="{ targetRoute: targetRoute }"
        @datachange="onSubData"
        @submit-success="onSubmitSuccess"
      ></label-tool-embed>
    </div>
    <div class="fallback" v-else-if="!loading">
      <p>{{ entry ? entry.message : entryError || "当前标注入口暂不可用，请返回列表后重新进入" }}</p>
    </div>
  </div>
</template>

<script>
import { entryKey, entryRouteKey } from "@/views/mixins/labelEntrySync";
import LabelToolEmbed from "@/views/certManagement/components/LabelToolEmbed.vue";
import { CONTRACT_URLS, MOCK_ENABLED, mockRejectInfo, mockLabelUrl } from "./components/labelTaskApi";

export default {
  name: "labelToolDetail",
  components: { LabelToolEmbed },
  data() {
    return {
      loading: false,
      entry: null,
      entryError: "",
      toolUrl: "",
      targetRoute: "",
      apiTaskId: "",
      rejectInfo: null,
      // 驳回摘要当前定位的 LS 任务 id（页头四条目跟随 LS 选中条目；同 id 事件去重不重复请求）
      lastRejectTaskId: "",
      // 详情定位键（mode/项目/任务包/任务）：同路由换参时用于检测并强制重建 micro-app 子应用
      lastDetailKey: "",
      // 驳回摘要是否已返回（整改页嵌入渲染守卫：首屏等摘要；isView 翻转源已随 2026-10-16 口径③移除）
      rejectInfoLoaded: false,
    };
  },
  computed: {
    isRectify() {
      return this.$route.query.mode === "rectify";
    },
    // ---- 嵌入参数（对齐 fe task-manage startAction/viewDetail + buildLink）----
    embedTaskId() {
      // 只接受当前已核实范围的任务定位，旧路由和旧核验结果不能补回任务。
      return this.apiTaskId || "";
    },
    embedStageRuleCode() {
      return (this.entry && this.entry.stageRuleCode) || "";
    },
    embedMode() {
      // 嵌入模式由当前授权入口裁决，旧路由不能重新赋予编辑资格。
      return (this.entry && this.entry.mode) || "";
    },
    embedIsView() {
      // 待整改：恒 false——2026-10-16 用户口径③：需整改=已整改≠流程结束，提交前页面必须保留
      // 「更新」+「提交」（实测摘要全整改后回页，旧 rejectDone 转只读会让两按钮一并消失、提交无入口）；
      // 实际只读由提交后的列表流转/锁状态接管。审核页：review-readonly 才是查看态
      if (this.isRectify) return false;
      return this.embedMode === "review-readonly";
    },
    /**
     * 识别详情页的真实业务定位，避免内部工具导航影响当前请求。
     * 参数：无。
     * @returns {string} 当前明细、人员、任务包、项目、条目及页面动作的稳定绑定键。
     */
    detailKey() {
      return entryRouteKey(this.$route.query);
    },
  },
  created() {
    this.lastDetailKey = this.detailKey;
    this.loadToolUrl();
    if (this.isRectify) {
      // 初始按路由 taskId 定位；LS 免登解析出的员工级 taskId（label-url 返回）与之不同时在 done 里补拉
      this.loadRejectInfo(this.$route.query.taskId || "");
    }
  },
  watch: {
    detailKey(v) {
      // 同路由换参（如审核详情→整改详情）时 Vue Router 复用组件、micro-app 子应用按 name keep-alive 复用
      // （iframe 沙箱档禁 v-if 原地重挂，见 LabelToolEmbed 头注），会残留旧 mode/旧任务列表 →
      // 强制整页刷新重建子应用（等价 LabelToolEmbed.reload() 兜底）
      if (v !== this.lastDetailKey) {
        this._entryDisposed = true;
        this.entry = null;
        this.toolUrl = "";
        window.location.reload();
      }
    },
  },
  /**
   * 销毁页面时使旧请求失效。
   * 参数：无。
   * @returns {void} 无。
   */
  beforeDestroy() {
    this._entryDisposed = true;
    this._entryRequest = (this._entryRequest || 0) + 1;
  },
  methods: {
    entryKey,
    // 返回时保留子应用，待列表路由完成后随页面销毁，避免卸载回写取消在途导航。
    goBack() {
      this._entryDisposed = true;
      this._entryRequest = (this._entryRequest || 0) + 1;
      this._returnAfterSyncKey = null;
      if (this.isRectify) {
        const { href } = this.$router.resolve({ path: "/labelRectificationList" });
        window.location.replace(href);
        return;
      }
      this.$router.replace("/labelAuditList");
    },
    // LS 页面地址（taskPackageGuid 优先，projectId 兜底——F0 两侧都支持；行无 LS 项目 id 时 projectId 为空仍可按任务包解析）
    loadToolUrl() {
      const request = this._entryRequest = (this._entryRequest || 0) + 1;
      const binding = this.entryKey();
      /**
       * 仅允许当前路由、身份和请求代次接收响应。
       * 参数：无。
       * @returns {boolean} 页面未销毁、请求代次未被替换且路由及身份绑定键完全相同时为true；任一变化为false。
       */
      const isCurrent = () => !this._entryDisposed && request === this._entryRequest && binding === this.entryKey();
      const { projectId, taskPackageGuid } = this.$route.query;
      if (!projectId && !taskPackageGuid) {
        this.$message.error("缺少任务包或项目参数");
        return;
      }
      this.entry = null;
      this.toolUrl = "";
      this.apiTaskId = "";
      this.entryError = "";
      this.loading = true;
      const done = (data) => {
        if (!isCurrent()) return;
        this.loading = false;
        this.entry = data || null;
        if (this._returnAfterSyncKey === binding && data && data.lsSyncState === "SYNCED") {
          this.goBack(); return;
        }
        if (data && data.url) {
          this.toolUrl = data.url;
          this.targetRoute = data.targetRoute || "";
          // 员工级 LS 任务 id 后端解析更准（多人拆分包按当前员工定位），优先于路由携带值
          if (data.taskId !== undefined && data.taskId !== null && data.taskId !== "") {
            this.apiTaskId = String(data.taskId);
            // 解析出的目标条目与初始定位不同：补拉一次驳回摘要（失败静默，保留初始结果）
            if (this.isRectify && this.apiTaskId !== String(this.lastRejectTaskId)) {
              this.loadRejectInfo(this.apiTaskId);
            }
          }
        }
      };
      if (MOCK_ENABLED) {
        mockLabelUrl(projectId).then(done).catch(() => (this.loading = false));
        return;
      }
      this.api
        .get(`/${serverConfig.msSalesPerformService}${CONTRACT_URLS.labelUrl}?mode=${this.$route.query.mode}&taskPackageGuid=${taskPackageGuid || ""}&projectId=${projectId || ""}&tenantGuid=${encodeURIComponent(localStorage.getItem("guid") || "")}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) done(res.data.data);
          else {
            if (!isCurrent()) return;
            this.loading = false;
            this.$message.error(res.data.msg || "标注工具地址获取失败");
          }
        })
        .catch(() => {
          if (!isCurrent()) return;
          this.loading = false;
        });
    },
    // 驳回摘要（F0 同构接口，结构对齐 fe label-review-record；失败时摘要区隐藏，页面降级可用）
    // taskId=LS 当前选中条目：页头四条目（驳回时间/驳回人/原因/当前条目）跟随选中条目；
    // 缺省时后端给"全包最新未整改"（兼容）；同 id 去重，LS 反复选中同一条目不重复请求
    loadRejectInfo(taskId = "") {
      const request = this._rejectRequest = (this._rejectRequest || 0) + 1;
      const binding = this.entryKey();
      /**
       * 仅允许当前路由、身份和请求代次接收响应。
       * 参数：无。
       * @returns {boolean} 页面未销毁、请求代次未被替换且路由及身份绑定键完全相同时为true；任一变化为false。
       */
      const isCurrent = () => !this._entryDisposed && request === this._rejectRequest && binding === this.entryKey();
      const tid = taskId === null || taskId === undefined ? "" : String(taskId);
      if (tid && tid === this.lastRejectTaskId) return;
      this.lastRejectTaskId = tid;
      const { projectId, taskPackageGuid } = this.$route.query;
      const done = (data) => {
        if (!isCurrent()) return;
        this.rejectInfo = data || {};
        this.rejectInfoLoaded = true;
      };
      // 失败/异常也置位：页面降级为可编辑（不因摘要缺失而空等）
      const fail = () => {
        if (!isCurrent()) return;
        this.rejectInfoLoaded = true;
      };
      if (MOCK_ENABLED) {
        mockRejectInfo().then(done).catch(fail);
        return;
      }
      this.api
        .get(`/${serverConfig.msSalesPerformService}${CONTRACT_URLS.rejectInfo}?taskPackageGuid=${taskPackageGuid || ""}&projectId=${projectId || ""}&taskId=${tid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) done(res.data.data);
          else fail();
        })
        .catch(fail);
    },
    onSubData(data) {
      // LS 切条目（selectTask）回传 TASK_CHANGED：页头驳回摘要跟随选中条目刷新
      if (data && data.type === "TASK_CHANGED" && data.taskId !== undefined && data.taskId !== null && data.taskId !== "") {
        this.loadRejectInfo(String(data.taskId));
        return;
      }
      // 预留：整改提交/审核操作完成后 LS 回传事件（驱动返回列表刷新）
      console.log("label tool datachange", data);
    },
    // LS 整包提交成功（UPDATE_SUCCESS 闭环，对齐 fe dataLabelSetting 提交后自动回列表）：提交审核/质检/验收/整改
    // 提交成功后提示并自动回来源列表（audit→审核列表 / rectify→待整改列表）；逐条通过/驳回不触发（LS 侧不发），
    // FBT 侧状态由 LS 回调 sync 驱动，列表页 keepAlive activated 会重查
    /**
     * 将工具通知作为重新核验当前范围的触发。
     * @param {*} data 外部响应数据。
     * @returns {void} 无。
     */
    onSubmitSuccess(data) {
      if (this._entryDisposed || !this.entry || (data && data.projectId != null && String(data.projectId) !== String(this.entry.projectId))) return;
      this._returnAfterSyncKey = this.entryKey();
      if (data && data.eventId) {
        const notice = this._returnAfterSyncKey + "|" + data.eventId;
        if (this._lastNotice === notice) return;
        this._lastNotice = notice;
      }
      this.toolUrl = "";
      this.loadToolUrl();
    },
  },
};
</script>

<style scoped>
.label-tool-detail {
  background: #fff;
  min-height: 100%;
}
.header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #e5e5e5;
  text-align: left;
}
/* 2026-10-08 样式反馈：返回按钮加边框化（与 labelExecution/labelTemplateEdit 返回按钮同一标准，
   灰边框+文字 #212121；原 teal 文字链接无边框） */
.back {
  color: #212121;
  cursor: pointer;
  font-size: 12px;
  width: 60px;
  height: 26px;
  line-height: 24px;
  text-align: center;
  padding: 0;
  box-sizing: border-box;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  background: #fff;
}
.page-title {
  margin-left: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #212121;
}
.proj-name {
  margin-left: 16px;
  font-size: 13px;
  color: #909399;
}
.reject-summary {
  padding: 10px 16px;
  border-bottom: 1px solid #ebeef5;
  background: #fafafa;
  font-size: 13px;
  color: #606266;
  text-align: left;
  line-height: 26px;
}
.sum-label {
  color: #909399;
}
.reject-reason {
  margin-top: 4px;
}
.stage {
  height: calc(100vh - 200px);
}
.fallback {
  padding: 60px 0;
  text-align: center;
  color: #909399;
}
</style>
